import * as React from 'react';
import { compose, withHandlers, onlyUpdateForKeys, withProps } from 'recompose';
import { withRouter } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import * as uuid from 'uuid/v4';
import { Card } from 'material-ui/Card';
import { withNotifications } from '@components/hoc/withNotifications';

import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import EntityDetailEnhancer from '@components/hoc/entityDetailEnhancer/EntityDetailEnhancer';

import * as T from '@modules/protocols/_protocolsTypes';
import { putProtocol, getProtocol } from '@modules/protocols/_protocolsActions';
import { ProtocolsFormBasic } from '@modules/protocols/ProtocolsFormBasic';
import { protocolCreateFormEnum } from '@modules/protocols/_protocolsEnums';

export const closeForm = '/warehouses/protocols';
export const enhance = compose<T.ProtocolsCreateFormProps, T.Outter & T.ProtocolsCreateFormProps>(
  withRouter,
  withNotifications({ putProtocol }),
  EntityDetailEnhancer<T.ProtocolEnhancerProps<T.Protocol>, T.Protocol>({
    getEntity: getProtocol,
    defaultEntity: {}
  }),
  onlyUpdateForKeys(['url', 'location']),
  withProps(({ entity }) => {
    return entity && entity.id
      ? {
          protocolType: protocolCreateFormEnum[entity.type],
          disabled: true
        }
      : {};
  }),
  withHandlers({
    closeItem: ({ history }) => async () => {
      history.push(closeForm);
    }
  }),
  withHandlers({
    onSubmit: ({ protocolType, closeItem, putProtocolNotify }) => async data => {
      const body = { id: data.id ? data.id : uuid(), type: protocolType.id.toUpperCase(), ...data };
      const result: boolean = await putProtocolNotify(body);
      if (result) {
        await closeItem();
      }
    }
  }),
  withProps<{}, T.ProtocolProps & T.Outter>(({ initialValues, entity }) => ({
    initialValues: {
      rows: [],
      ...entity,
      ...initialValues // for testing purposes
    }
  })),
  breadcrumbs(({ protocolType, entity }) => [
    { label: 'Skladové doklady', to: '/warehouses/protocols' },
    { label: entity && entity.id ? 'Upravit Poznámku' : protocolType.label }
  ]),
  reduxForm({
    form: 'ProtocolsGrid'
  })
);

export const View: React.SFC<T.Outter & T.ProtocolsCreateFormProps> = props => (
  <div>
    <form className="layout" onSubmit={props.handleSubmit}>
      <Card>
        <ProtocolsFormBasic protocolType={props.protocolType} disabled={props.disabled} />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={props.closeItem} />
      </Card>
    </form>
  </div>
);

export const ProtocolsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/protocols/ProtocolsForm.tsx